const Space = ({ size }) => {
  return <div style={{ width: size, height: size }} />
}

export default Space
